import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: useRuntimeConfig().public.sentry.dsn,
  environment: useRuntimeConfig().public.sentry.environment,
  release: useRuntimeConfig().public.sentry.release,
  sampleRate: 0.5,
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.3,
  replaysOnErrorSampleRate: 1.0,
  ignoreTransactions: ['OptanonGroupId', 'ttd_dom_ready', 'TenantFeatures', 'DomainData', 'pagead2.googlesyndication.com', 'otBannerSdk'],
  profilesSampleRate: 0.5,
  integrations: [
    Sentry.piniaIntegration(usePinia()),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      blockAllMedia: true,
    }),
  ],
})
